var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOneDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62653 9.55807L13.8253 12.0723L16.3271 11.0194C16.8355 10.7997 17.3836 10.687 17.9375 10.6875C18.0298 10.6875 18.121 10.6917 18.2117 10.6977C17.9109 9.52488 17.276 8.46463 16.384 7.64583C15.492 6.82703 14.3814 6.28494 13.1871 6.08543C11.9928 5.88593 10.7663 6.03759 9.65661 6.522C8.54691 7.00641 7.60179 7.8027 6.93611 8.81411C6.9575 8.81384 6.97856 8.8125 7 8.8125C7.92791 8.81124 8.83767 9.06949 9.62653 9.55807Z",
    fill: "#0364B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62653 9.55807C8.83767 9.06949 7.92791 8.81124 7 8.8125C6.97856 8.8125 6.9575 8.81384 6.93611 8.81411C6.02793 8.82535 5.13996 9.08386 4.36766 9.56186C3.59536 10.0399 2.96791 10.7193 2.55273 11.5271C2.13756 12.3349 1.95036 13.2406 2.01125 14.1468C2.07214 15.053 2.37881 15.9255 2.89832 16.6705L13.8253 12.0723L9.62653 9.55807Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2117 10.6977C18.121 10.6917 18.0298 10.6875 17.9375 10.6875C17.3836 10.687 16.8355 10.7997 16.3271 11.0194L13.8253 12.0723L21.5141 16.6778C21.8364 16.0794 22.0035 15.4096 21.9999 14.7299C21.9964 14.0502 21.8224 13.3822 21.4938 12.7872C21.1652 12.1921 20.6925 11.6891 20.1191 11.324C19.5457 10.959 18.8899 10.7436 18.2117 10.6977Z",
    fill: "#1490DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8253 12.0723L2.89832 16.6705C3.35843 17.332 3.9718 17.8723 4.68605 18.2453C5.4003 18.6183 6.19422 18.8129 7 18.8125H17.9375C18.6708 18.8127 19.3906 18.6144 20.0203 18.2385C20.65 17.8627 21.1662 17.3234 21.5141 16.6778L13.8253 12.0723Z",
    fill: "#28A8EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOneDrive);
export default __webpack_public_path__ + "static/media/Logo_OneDrive.f90da8f56031a179177488d604808fd4.svg";
export { ForwardRef as ReactComponent };